import React, { useEffect, useState, useContext } from 'react';
import { useNavigate } from 'react-router-dom';
import { IsLoginContext, useIsLoginState } from 'auth/IsLoginContext'
import { validateToken, parsePermissionsFromToken } from 'auth/ValidateToken';
import qs from "querystring";

const Navigate = () => {
    const navigate = useNavigate();
    // 로그인 정보
    const { setIsLogin } = useContext(IsLoginContext);
    const isLogin = useIsLoginState();

    useEffect(() => {
        const authorize = async () => {
          const accessToken = localStorage.getItem('access_token');
          const tvresult = await validateToken(accessToken);
          if (!tvresult) {
            navigate("/unauthorized")
          }

          const permissions = await parsePermissionsFromToken(accessToken);
          if (permissions.length === 0) {
            navigate("/unauthorized")
          }

          if (permissions.includes('finance')) {
            navigate("/finance");
          } else if (permissions.includes('bizops')) {
            navigate("/bizops");
          }
        };

        authorize();
      })

    useEffect(() => {

    },[]);

    return <div>loading...</div>
}

export default Navigate;

